<template>
    <div class="d-flex align-items-center">
        <confirm-box ref="confirm"></confirm-box>
        <div class="me-2">
            <button class="btn btn-sm me-1 btn-secondary" title="Remove user from district" @click="askRemove"><i class="fa-solid fa-user-minus"></i></button>
        </div>
        <div class="d-flex flex-column flex-grow-1">
            <span class="h5 text-primary m-0">{{ user.name }}</span>
            <span class="h6 text-muted m-0">{{ user.email }}</span>
        </div>

        <div class="btn-group" role="group">
            <button id="user-status-dropdown" type="button" class="btn btn-sm dropdown-toggle" :class="statusButtonClass" data-bs-toggle="dropdown" aria-expanded="false"
                v-html="statusLabel"
            >
            </button>
            <ul class="user-status-dropdown dropdown-menu" aria-labelledby="user-status-dropdown">
                <li><a class="dropdown-item" href="javascript:void(0)" @click="update(0)"><i class="fa-solid fa-user-slash me-2"></i>Banned</a></li>
                <li><a class="dropdown-item" href="javascript:void(0)" @click="update(1)"><i class="fa-solid fa-user me-2"></i>Normal</a></li>
                <li><a class="dropdown-item" href="javascript:void(0)" @click="update(3)"><i class="fa-solid fa-users me-2"></i>Student Mananger</a></li>
                <li><a class="dropdown-item" href="javascript:void(0)" @click="update(5)"><i class="fa-solid fa-building-user me-2"></i>District Mananger</a></li>
            </ul>
        </div>

    </div>
</template>

<script>
import ConfirmBox from './ConfirmBox.vue';

export default {
    components: { ConfirmBox },

    props: {
        user: {
            type: Object,
            default: function(data={}) {
                return {
                    id: data.id ?? null,
                    name: data.name ?? '',
                    email: data.email ?? '',
                    status: data.status ?? 1,
                    user_district_id: data.user_district_id ?? null,
                };
            },
        },

        value: {
            type: Number,
            required: true,
        }

    },

    data() {
        return {
            user_district_status: this.value,
        }
    },

    computed: {
        statusLabel: function() {
            switch (this.user_district_status) {
                case 0:
                    return '<i class="fa-solid fa-user-slash me-2"></i>Banned';
                case 3:
                    return '<i class="fa-solid fa-users me-2"></i>Student Mananger';
                case 5:
                    return '<i class="fa-solid fa-building-user me-2"></i>District Mananger';
                default:
                    return '<i class="fa-solid fa-user me-2"></i>Normal';
            }
        },

        statusButtonClass: function() {
            switch (this.user_district_status) {
                case 0:
                    return 'btn-danger';
                case 3:
                    return 'btn-primary';
                case 5:
                    return 'btn-success';
                default:
                    return 'btn-outline-secondary';
            }
        },
    },

    methods: {
        askRemove: function() {
            this.$refs.confirm.show({
                content: `Are you sure you would like to remove the user <b>${this.user.name}</b> from the district? Note that ` +
                    "this will not delete the user, only the user's, relationship to the district.",
                title: 'Remove User',
                callback: () => { this.remove() }
            });
        },

        remove() {
            this.isLoading = true;
            axios
                .delete(`/api/admin/districts/users/${this.user.user_district_id}`)
                .then(resonse => {
                    this.$emit('delete', this.user.id);
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.isLoading = false;
                })
        },

        update: function(status) {
            this.$parent.isLoading = true;
            const data = { status: status }
            axios
                .patch(`/api/admin/districts/users/${this.user.user_district_id}`, data)
                .then(response => {
                    this.user_district_status = response.data.status;
                    this.$emit('input', this.user_district_status);
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.$parent.isLoading = false;
                });
        },


    },
}
</script>

<style scoped>
.user-status-dropdown i {
    text-align: center;
    width: 1.5em;
}
</style>